module.exports = __webpack_public_path__ + "static/media/appointmentdirect.09ec2af8.svg";